import { Edit2Outline, FileOutline } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const { title, createDescription } = RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Exercise];

const config: ContentConfigProps = {
  routes: {
    create: routes.ExerciseCreator,
    edit: routes.ExerciseEditor,
    duplicate: routes.ExerciseDuplicate,
    details: routes.ExerciseDetails,
    manageDetails: routes.AdminExerciseDetails,
    review: routes.ExerciseSubmission,
    manageReview: routes.ExerciseSubmissionReview,
  },
  label: { title, createDescription },
  icons: {
    Type: FileOutline,
    Create: Edit2Outline,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
